module.exports = __webpack_public_path__ + "static/media/Group (6).ce3e05f2.svg";